import PropTypes from "prop-types";
import AssetDetails from "../common/AssetDetails";
import ReactECharts from "echarts-for-react";
import createBatteryOption from "../common/graphs-config/battery";
import humidityOptionsCreator from "../common/graphs-config/humidity";
import { useRef, useState } from "react";
import { Body } from "@vds/typography";
import { Button } from "@vds/buttons";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBatteryHistoryRequest,
  fetchHumidityRequest,
  fetchPressureRequest,
  fetchRSSIHistoryRequest,
  fetchTemperatureRequest,
  fetchShockAlarmHistoryRequest,
} from "../../../store/actions/deviceShipmentsDashboard";
import { useEffect } from "react";
import { isMoreThan7Days } from "../../../global/utility/GmtToLocal";
import createPressureOption from "../common/graphs-config/pressure";
import createTemperatureOption from "../common/graphs-config/temperature";
import createRssiOption from "../common/graphs-config/rssi";
import shockOptions from "../common/graphs-config/shock";

function AssetDataView({ deviceid, startDate, endDate }) {
  const dispatch = useDispatch();
  const { battery, humidity, temperature, pressure, rssi, shock } = useSelector((state) => ({
    battery: {
      isLoading: state?.shipmentDashboard?.isLoading?.battery,
      data: state?.shipmentDashboard?.data?.batteryHistory?.battery || [],
    },
    humidity: {
      isLoading: state?.shipmentDashboard?.isLoading?.humidity,
      data: state?.shipmentDashboard?.data?.Humidity?.humidity || [],
    },
    temperature: {
      isLoading: state?.shipmentDashboard?.isLoading?.temperature,
      data: state?.shipmentDashboard?.data?.Temperature?.temperature || [],
    },
    pressure: {
      isLoading: state?.shipmentDashboard?.isLoading?.pressure,
      data: state?.shipmentDashboard?.data?.Pressure?.pressure || [],
    },
    rssi: {
      isLoading: state?.shipmentDashboard?.isLoading?.rssi,
      data: state?.shipmentDashboard?.data?.rssiHistory?.rssi || [],
    },
    shock: {
      isLoading: state?.shipmentDashboard?.isLoading?.shockAlarmHistory,
      data: state?.shipmentDashboard?.data?.shockAlarmHistory?.shock || [],
    },
  }));
  const {
    singleDeviceType,
  } = useSelector((state) => ({
    singleDeviceType: state?.asset?.singleDeviceType || [],
  }));
  const [dates, setDates] = useState({
    startDate: dayjs(
      isMoreThan7Days(startDate || Date.now(), Date.now())
        ? dayjs(Date.now()).subtract(7, "day")
        : dayjs(startDate || Date.now())
    ),
    endDate: 
    dayjs(
      isMoreThan7Days(startDate || Date.now(), Date.now())
        ? dayjs(Date.now())
        : dayjs(endDate || Date.now())
    )
  });
  // const {
  //   singleDeviceType,
  // } = useSelector((state) => ({
  //   singleDeviceType: state?.asset?.singleDeviceType || [],
  // }));
  // const [dates, setDates] = useState({
  //   startDate: dayjs(
  //     // isMoreThan7Days( Date.now(), Date.now())
  //        dayjs( Date.now()).subtract(7, "day")
  //       // : dayjs( Date.now())
  //   ),
  //   endDate: dayjs(Date.now()),
  // });
  const attributes = singleDeviceType?.devicetypes && singleDeviceType?.devicetypes[0]?.attributes || [];
 const foundHumidity = attributes.find(attr => attr.name === 'Humidity');
      const foundBattery = attributes.find(attr => attr.name === 'Battery');
      const foundPressure = attributes.find(attr => attr.name === 'Pressure');
      const foundTemperature = attributes.find(attr => attr.name === 'Temperature');
      const foundRssi = attributes.find(attr => attr.name === 'Rssi');
      const foundShock = attributes.find(attr => attr.name === 'Shock');
  useEffect(() => {
    if (deviceid) {
       if (singleDeviceType && singleDeviceType.devicetypes && singleDeviceType.devicetypes.length > 0) {
      const attributes = singleDeviceType.devicetypes[0].attributes;

      // Use the find() method to get the humidity attribute object
      const foundHumidity = attributes.find(attr => attr.name === 'Humidity');
      const foundBattery = attributes.find(attr => attr.name === 'Battery');
      const foundPressure = attributes.find(attr => attr.name === 'Pressure');
      const foundTemperature = attributes.find(attr => attr.name === 'Temperature');
if (foundBattery) {
      dispatch(
        fetchBatteryHistoryRequest({
          id: deviceid,
          startDateTime: dates?.startDate?.toISOString(),
          endDateTime: dates?.endDate?.toISOString(),
        })
      );
}
if (foundHumidity) {
      dispatch(
        fetchHumidityRequest({
          id: deviceid,
          startDateTime: dates?.startDate?.toISOString(),
          endDateTime: dates?.endDate?.toISOString(),
        })
      );
}
if (foundTemperature) {
      dispatch(
        fetchTemperatureRequest({
          id: deviceid,
          startDateTime: dates?.startDate?.toISOString(),
          endDateTime: dates?.endDate?.toISOString(),
        })
      );
}
if (foundPressure) {
      dispatch(
        fetchPressureRequest({
          id: deviceid,
          startDateTime: dates?.startDate?.toISOString(),
          endDateTime: dates?.endDate?.toISOString(),
        })
      );
}
const foundShock = attributes.find(attr => attr.name === 'Shock');
if (foundShock) {
      dispatch(
        fetchShockAlarmHistoryRequest({
          id: deviceid,
          startDateTime: dates?.startDate?.toISOString(),
          endDateTime: dates?.endDate?.toISOString(),
        })
      );
}
    }
  }
  }, [deviceid,singleDeviceType]);

  const chartRefs = {
    battery: useRef(null),
    humidity: useRef(null),
    temperature: useRef(null),
    pressure: useRef(null),
    rssi: useRef(null),
    shock: useRef(null),
  };

  const yAxisLabelsRefs = {
    battery: useRef([]),
    humidity: useRef([]),
    temperature: useRef([]),
    pressure: useRef([]),
    rssi: useRef([]),
    shock: useRef([]),
  };

  const chartCreators = {
    battery: createBatteryOption,
    humidity: humidityOptionsCreator,
    temperature: createTemperatureOption,
    pressure: createPressureOption,
    rssi: createRssiOption,
    shock: () => shockOptions,
  };

  const attributeMap = {
    battery: [],
    humidity: [],
    temperature: [],
    pressure: [],
    rssi: [],
  };

  const getChart = (
    key,
    label,
    data = [],
    isLoading = false,
    height = "350px"
  ) => {
    const option = chartCreators[key](
      attributeMap[key],
      data,
      yAxisLabelsRefs[key].current
    );
 
    return (
      <div className="ats-asset-details ats-asset-details-graph" key={key}>
        <div className="d-flex flex-column">
          <div className="ats-asset-details-graph-header">
            <Body size="small" color="#6F7171">
              {label}
            </Body>
          </div>
          <div>
            <ReactECharts
              showLoading={isLoading}
              style={{ height }}
              option={{
                ...option,
                series: [
                  {
                    ...option?.series[0],
                    data: Array.isArray(option?.series[0]?.data) && option?.series[0]?.data?.length === 0 ? data  : option?.series[0]?.data,
                  },
                ],
              }}
              notMerge={true}
              opts={{ renderer: "svg" }}
              onChartReady={(chart) => {
                chartRefs[key].current = chart;
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const onChangeDate = (type, date) => {
    if (type === "start") {
      setDates((prev) => ({ ...prev, startDate: date }));
    }

    if (type === "end") {
      setDates((prev) => ({ ...prev, endDate: date }));
    }
  };

  const handleApplyClick = () => {
    const startDate = dates?.startDate;
    const endDate = dates?.endDate;

    if (startDate && endDate && startDate.isAfter(endDate)) {
      return;
    }

    // Fetch data based on selected dates
    dispatch(
      fetchBatteryHistoryRequest({
        id: deviceid,
        startDateTime: dates?.startDate?.toISOString(),
        endDateTime: dates?.endDate?.toISOString(),
      })
    );
    dispatch(
      fetchHumidityRequest({
        id: deviceid,
        startDateTime: dates?.startDate?.toISOString(),
        endDateTime: dates?.endDate?.toISOString(),
      })
    );
    dispatch(
      fetchPressureRequest({
        id: deviceid,
        startDateTime: dates?.startDate?.toISOString(),
        endDateTime: dates?.endDate?.toISOString(),
      })
    );
    dispatch(
      fetchTemperatureRequest({
        id: deviceid,
        startDateTime: dates?.startDate?.toISOString(),
        endDateTime: dates?.endDate?.toISOString(),
      })
    );
     dispatch(
      fetchRSSIHistoryRequest({
        id: deviceid,
        startDateTime: dates?.startDate?.toISOString(),
        endDateTime: dates?.endDate?.toISOString(),
      })
    );
  };

  return (
    <div>
      <AssetDetails />
      <div className="d-flex justify-content-between align-items-center gap-2 ats-asset-details">
        <div className="w-100 d-flex flex-column">
          <Body size="small" color="#000000">
            Start date and time
          </Body>
          <DatePicker
            data-testid="start-date-picker"
            className="w-100"
            showTime
            allowClear={false}
            format="MM-DD-YYYY HH:mm"
            onChange={(value) => onChangeDate("start", value)}
            value={dates.startDate}
            // minDate={dayjs(startDate || Date.now())}
            // maxDate={dayjs(endDate || Date.now())}
            style={{
              width: "100%",
              height: "44px", // Increased height for DatePicker
              border: "1px solid black", // Black border for DatePicker
              borderRadius: "4px", // Optional rounded corners
            }}
          />
        </div>
        <div className="w-100 d-flex flex-column">
          <Body size="small" color="#000000">
            End date and time
          </Body>
          <DatePicker
            data-testid="end-date-picker"
            className="w-100"
            showTime
            allowClear={false}
            format="MM-DD-YYYY HH:mm"
            onChange={(value) => onChangeDate("end", value)}
            value={dates.endDate}
            // minDate={dayjs(startDate || Date.now())}
            // maxDate={dayjs(endDate || Date.now())}
            style={{
              width: "100%",
              height: "44px", // Increased height for DatePicker
              border: "1px solid black", // Black border for DatePicker
              borderRadius: "4px", // Optional rounded corners
            }}
          />
        </div>
        <div className="mt-3">
          <Button
            size="medium"
            disabled={false}
            use="secondary"
            onClick={handleApplyClick}
          >
            Apply
          </Button>
        </div>
      </div>
      { foundBattery && getChart("battery", "Battery", battery?.data || [], battery.isLoading)}
      { foundHumidity && getChart("humidity", "Humidity", humidity?.data || [], humidity.isLoading)}
      { foundTemperature && getChart("temperature", "Temperature", temperature?.data || [], temperature.isLoading)}
      { foundPressure && getChart("pressure", "Pressure", pressure?.data || [], pressure.isLoading)}
      {  getChart("rssi", "Rssi", rssi?.data || [], rssi.isLoading)}
      { foundShock && getChart("shock", "Shock Alarm", shock?.data?.map(item => [item[0], item[1]]) || [], shock.isLoading)}
    </div>
  );
}

AssetDataView.propTypes = {
  deviceid: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default AssetDataView;